var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState, useMemo, useCallback } from "react";
import { Box, Typography, Card, Stack, Button, Select, Option, Chip, Skeleton, FormControl, Link, } from "@mui/joy";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import DownloadIcon from "@mui/icons-material/Download";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { ModuleRegistry, } from "ag-grid-community";
import { useColorScheme } from "@mui/joy/styles";
import { useNavigate } from "react-router-dom";
import { useCostDashboard } from "../../data/hooks/useCostDashboard";
import { useCallAnalytics } from "../../data/hooks/useCallAnalytics";
import { FilterEnums } from "../../types/enums";
import { formatCurrency, formatDuration } from "../../utils";
import "./styles/styles.css";
// Chart.js imports
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend, } from "chart.js";
import { Line } from "react-chartjs-2";
// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend);
ModuleRegistry.registerModules([]);
// Map frontend column field names to backend field names
var mapSortFieldToBackend = function (frontendField) {
    var fieldMap = {
        'sessionId': 'SessionId',
        'callStart': 'CallStart',
        'callEnd': 'CallEnd',
        'billableMinutes': 'BillableMinutes',
        'llmModel': 'LlmModel',
        'ttsModel': 'TtsModel',
        'sttModel': 'SttModel',
        'cost.total': 'TotalCost',
        'cost.llm': 'LlmCost',
        'cost.tts': 'TtsCost',
        'cost.stt': 'SttCost',
        'cost.telephony': 'TelephonyCost',
        'cost.transferTelephony': 'TransferTelephonyCost',
        'transferMinutes': 'TransferMinutes',
        'isOutbound': 'IsOutbound',
        'isLiveAgentRequested': 'IsLiveAgentRequested'
    };
    return fieldMap[frontendField] || frontendField;
};
function makeDatasource(getCostDashboardData, filter, selectedFlow, selectedCallFlow, customStartDate, customEndDate, includeOutbound, includeLiveAgent, caller, pageSize, sortField, sortOrder) {
    return {
        getRows: function (params) {
            return __awaiter(this, void 0, void 0, function () {
                var page, mappedSortField, response, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            page = params.startRow / pageSize + 1;
                            mappedSortField = sortField ? mapSortFieldToBackend(sortField) : "CallStart";
                            console.log('Sorting Debug:', {
                                originalSortField: sortField,
                                mappedSortField: mappedSortField,
                                sortOrder: sortOrder || "desc",
                                page: page
                            });
                            return [4 /*yield*/, getCostDashboardData(filter, selectedFlow || undefined, selectedCallFlow || undefined, customStartDate, customEndDate, includeOutbound, includeLiveAgent, caller || undefined, page, pageSize, mappedSortField, sortOrder || "desc")];
                        case 1:
                            response = _a.sent();
                            if (response && response.sessions && response.pageInfo) {
                                params.successCallback(response.sessions, response.pageInfo.totalItems);
                            }
                            else {
                                params.successCallback([], 0);
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            console.error('Datasource fetch error', e_1);
                            params.failCallback();
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
    };
}
export var CostDashboard = function () {
    var mode = useColorScheme().mode;
    var _a = useState(mode === "dark"), darkMode = _a[0], setDarkMode = _a[1];
    var navigate = useNavigate();
    var gridApi = useRef(null);
    var PAGE_SIZE = 50;
    var _b = useCostDashboard(), costDashboardData = _b.costDashboardData, isLoadingCostDashboard = _b.isLoadingCostDashboard, getCostDashboard = _b.getCostDashboard, getCostDashboardData = _b.getCostDashboardData, modelUsageData = _b.modelUsageData, isLoadingModelUsage = _b.isLoadingModelUsage, getModelUsageBreakdown = _b.getModelUsageBreakdown, exportCostDashboardCSV = _b.exportCostDashboardCSV;
    var _c = useCallAnalytics(), flows = _c.flows, getFlows = _c.getFlows;
    // ---- FILTER STATE ---- (matching Dashboard exactly)
    var _d = useState(FilterEnums.last7Days), filter = _d[0], setDateRange = _d[1];
    var _e = useState("daily"), grouping = _e[0], setGrouping = _e[1];
    // Store the actual selected custom range
    var _f = useState(null), customStartDate = _f[0], setCustomStartDate = _f[1];
    var _g = useState(null), customEndDate = _g[0], setCustomEndDate = _g[1];
    // For react-date-range usage
    var _h = useState(false), dateRangePickerVisible = _h[0], setShowDateRangePicker = _h[1];
    var dateRangeRef = useRef(null);
    var _j = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        },
    ]), selectedRange = _j[0], setSelectedRange = _j[1];
    // Additional filters specific to cost dashboard
    var _k = useState(""), selectedFlow = _k[0], setSelectedFlow = _k[1];
    var _l = useState(""), selectedCallFlow = _l[0], setSelectedCallFlow = _l[1];
    var _m = useState(false), includeOutbound = _m[0], setIncludeOutbound = _m[1];
    var _o = useState(false), includeLiveAgent = _o[0], setIncludeLiveAgent = _o[1];
    var _p = useState(""), caller = _p[0], setCaller = _p[1];
    // Helper: Display the selected date range in the dropdown
    var displayRange = function () {
        if (!customStartDate || !customEndDate)
            return "Custom Range";
        return "".concat(customStartDate.toLocaleDateString(), " - ").concat(customEndDate.toLocaleDateString());
    };
    var resetDatasource = useCallback(function (sortField, sortOrder) {
        if (!gridApi.current)
            return;
        gridApi.current.setGridOption('datasource', makeDatasource(getCostDashboardData, filter, selectedFlow, selectedCallFlow, customStartDate, customEndDate, includeOutbound, includeLiveAgent, caller, PAGE_SIZE, sortField, sortOrder));
    }, [
        getCostDashboardData,
        filter,
        selectedFlow,
        selectedCallFlow,
        customStartDate,
        customEndDate,
        includeOutbound,
        includeLiveAgent,
        caller,
    ]);
    var onGridReady = useCallback(function (e) {
        gridApi.current = e.api;
        resetDatasource();
    }, [resetDatasource]);
    // Load summary data separately from the table data
    var loadSummaryData = useCallback(function () {
        getCostDashboard(filter, selectedFlow, selectedCallFlow, customStartDate, customEndDate, includeOutbound, includeLiveAgent, caller, 1, // Just get first page for summary data
        1, // Small page size since we only need summary
        "CallStart", "desc");
    }, [
        filter,
        selectedFlow,
        selectedCallFlow,
        customStartDate,
        customEndDate,
        includeOutbound,
        includeLiveAgent,
        caller,
    ]);
    // Export CSV functionality
    var handleExportCSV = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, exportCostDashboardCSV(filter, selectedFlow || undefined, selectedCallFlow || undefined, customStartDate, customEndDate, includeOutbound, includeLiveAgent, caller || undefined)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Export failed:', error_1);
                    alert('Failed to export CSV. Please try again.');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [
        exportCostDashboardCSV,
        filter,
        customStartDate,
        customEndDate,
        selectedFlow,
        selectedCallFlow,
        includeOutbound,
        includeLiveAgent,
        caller,
    ]);
    useEffect(function () {
        setDarkMode(mode === "dark");
    }, [mode]);
    useEffect(function () {
        getFlows();
    }, []);
    // Initial data load - separate from filter changes
    useEffect(function () {
        loadSummaryData();
    }, []);
    // Hide the date picker if clicking outside
    useEffect(function () {
        function handleClickOutside(event) {
            if (dateRangeRef.current &&
                !dateRangeRef.current.contains(event.target)) {
                setShowDateRangePicker(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // Reset datasource when filters change
    useEffect(function () {
        if (gridApi.current) {
            resetDatasource();
            // Also load summary and model usage data for the charts
            loadSummaryData();
            getModelUsageBreakdown(filter, customStartDate, customEndDate);
        }
    }, [
        filter,
        customStartDate,
        customEndDate,
        selectedFlow,
        selectedCallFlow,
        includeOutbound,
        includeLiveAgent,
        caller,
    ]);
    var renderCostMetricsCards = function () {
        if (isLoadingCostDashboard) {
            return (_jsx(Stack, __assign({ direction: "row", spacing: 2, sx: { mb: 3 } }, { children: [1, 2, 3, 4].map(function (index) { return (_jsx(Card, __assign({ sx: { flex: 1 } }, { children: _jsx(Skeleton, { variant: "rectangular", height: 100 }) }), index)); }) })));
        }
        if (!(costDashboardData === null || costDashboardData === void 0 ? void 0 : costDashboardData.summary)) {
            return (_jsxs(Stack, __assign({ direction: "row", spacing: 2, sx: { mb: 3 } }, { children: [_jsxs(Card, __assign({ sx: { flex: 1 } }, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", spacing: 1 }, { children: [_jsx(AttachMoneyIcon, {}), _jsx(Typography, __assign({ level: "body-sm", color: "neutral" }, { children: "Total Cost" }))] })), _jsx(Typography, __assign({ level: "h2" }, { children: "Loading..." }))] })), _jsxs(Card, __assign({ sx: { flex: 1 } }, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", spacing: 1 }, { children: [_jsx(QueryStatsIcon, {}), _jsx(Typography, __assign({ level: "body-sm", color: "neutral" }, { children: "Total Sessions" }))] })), _jsx(Typography, __assign({ level: "h2" }, { children: "Loading..." }))] })), _jsxs(Card, __assign({ sx: { flex: 1 } }, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", spacing: 1 }, { children: [_jsx(TrendingUpRoundedIcon, {}), _jsx(Typography, __assign({ level: "body-sm", color: "neutral" }, { children: "Avg Cost Per Session" }))] })), _jsx(Typography, __assign({ level: "h2" }, { children: "Loading..." }))] })), _jsxs(Card, __assign({ sx: { flex: 1 } }, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", spacing: 1 }, { children: [_jsx(SmartToyIcon, {}), _jsx(Typography, __assign({ level: "body-sm", color: "neutral" }, { children: "Total Billable Minutes" }))] })), _jsx(Typography, __assign({ level: "h2" }, { children: "Loading..." }))] }))] })));
        }
        var summary = costDashboardData.summary;
        return (_jsxs(Stack, __assign({ direction: "row", spacing: 2, sx: { mb: 3 } }, { children: [_jsxs(Card, __assign({ sx: { flex: 1 } }, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", spacing: 1 }, { children: [_jsx(AttachMoneyIcon, {}), _jsx(Typography, __assign({ level: "body-sm", color: "neutral" }, { children: "Total Cost" }))] })), _jsx(Typography, __assign({ level: "h2" }, { children: formatCurrency((summary === null || summary === void 0 ? void 0 : summary.totalCost) || 0) }))] })), _jsxs(Card, __assign({ sx: { flex: 1 } }, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", spacing: 1 }, { children: [_jsx(QueryStatsIcon, {}), _jsx(Typography, __assign({ level: "body-sm", color: "neutral" }, { children: "Total Calls" }))] })), _jsx(Typography, __assign({ level: "h2" }, { children: (summary === null || summary === void 0 ? void 0 : summary.totalSessions) || 0 }))] })), _jsxs(Card, __assign({ sx: { flex: 1 } }, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", spacing: 1 }, { children: [_jsx(TrendingUpRoundedIcon, {}), _jsx(Typography, __assign({ level: "body-sm", color: "neutral" }, { children: "Avg Cost Per Calls" }))] })), _jsx(Typography, __assign({ level: "h2" }, { children: formatCurrency((summary === null || summary === void 0 ? void 0 : summary.averageCostPerSession) || 0) }))] })), _jsxs(Card, __assign({ sx: { flex: 1 } }, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", spacing: 1 }, { children: [_jsx(SmartToyIcon, {}), _jsx(Typography, __assign({ level: "body-sm", color: "neutral" }, { children: "Total Billable Time" }))] })), _jsx(Typography, __assign({ level: "h2" }, { children: formatDuration((summary === null || summary === void 0 ? void 0 : summary.totalBillableMinutes) || 0) }))] }))] })));
    };
    var renderDailyCostChart = function () {
        if (isLoadingCostDashboard) {
            return (_jsxs(Card, __assign({ sx: { mb: 3 } }, { children: [_jsx(Typography, __assign({ level: "title-lg", sx: { mb: 2 } }, { children: "Daily Cost Trends" })), _jsx(Skeleton, { variant: "rectangular", height: 400 })] })));
        }
        if (!(costDashboardData === null || costDashboardData === void 0 ? void 0 : costDashboardData.dailyStats) || costDashboardData.dailyStats.length === 0) {
            return null;
        }
        var dailyStats = costDashboardData.dailyStats;
        // Prepare chart data
        var chartData = {
            labels: dailyStats.map(function (stat) {
                var date = new Date(stat.date);
                return date.toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric'
                });
            }),
            datasets: [
                {
                    label: 'Daily Cost',
                    data: dailyStats.map(function (stat) { return parseFloat(parseFloat(stat.cost).toFixed(2)); }),
                    borderColor: 'rgb(53, 162, 235)',
                    backgroundColor: 'rgba(53, 162, 235, 0.5)',
                    tension: 0.1,
                },
                {
                    label: 'Sessions',
                    data: dailyStats.map(function (stat) { return stat.sessions; }),
                    borderColor: 'rgb(255, 99, 132)',
                    backgroundColor: 'rgba(255, 99, 132, 0.5)',
                    yAxisID: 'y1',
                    tension: 0.1,
                }
            ],
        };
        var chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            interaction: {
                mode: 'index',
                intersect: false,
            },
            plugins: {
                legend: {
                    display: true,
                },
                tooltip: {
                    callbacks: {
                        label: function (context) {
                            var label = context.dataset.label || '';
                            if (label) {
                                label += ': ';
                            }
                            if (context.dataset.label === 'Daily Cost') {
                                label += '$' + parseFloat(context.parsed.y).toFixed(2);
                            }
                            else {
                                label += context.parsed.y;
                            }
                            return label;
                        }
                    }
                }
            },
            scales: {
                x: {
                    display: true,
                    title: {
                        display: true,
                        text: 'Date'
                    }
                },
                y: {
                    type: 'linear',
                    display: true,
                    position: 'left',
                    title: {
                        display: true,
                        text: 'Cost ($)'
                    },
                    ticks: {
                        callback: function (value) {
                            return '$' + parseFloat(value).toFixed(2);
                        }
                    }
                },
                y1: {
                    type: 'linear',
                    display: true,
                    position: 'right',
                    title: {
                        display: true,
                        text: 'Sessions'
                    },
                    grid: {
                        drawOnChartArea: false,
                    },
                },
            },
        };
        return (_jsxs(Card, __assign({ sx: { mb: 3 } }, { children: [_jsx(Typography, __assign({ level: "title-lg", sx: { mb: 2 } }, { children: "Daily Cost Trends" })), _jsx(Box, __assign({ sx: { height: 400, width: '100%' } }, { children: _jsx(Line, { data: chartData, options: chartOptions }) }))] })));
    };
    // Navigation handler for session ID clicks
    var handleSessionClick = function (sessionId) {
        navigate("/call-conversations?sessionId=".concat(sessionId));
    };
    // AG-Grid sorting handler
    var onSortChanged = useCallback(function (event) {
        var sortState = event.api.getColumnState();
        var sortedColumn = sortState.find(function (col) { return col.sort; });
        if (sortedColumn) {
            resetDatasource(sortedColumn.colId, sortedColumn.sort || "asc");
        }
        else {
            resetDatasource();
        }
    }, [resetDatasource]);
    // AG-GRID Definitions
    var defaultColDef = useMemo(function () { return ({
        filter: false,
        resizable: true,
        sortable: true,
    }); }, []);
    var columnDefs = useMemo(function () { return [
        {
            headerName: "Session ID",
            field: "sessionId",
            flex: 1,
            minWidth: 120,
            cellRenderer: function (params) { return (_jsx(Link, __assign({ component: "button", onClick: function () { return handleSessionClick(params.value); }, sx: {
                    textDecoration: "underline",
                    cursor: "pointer",
                    color: "primary.500",
                    "&:hover": {
                        color: "primary.600",
                    },
                } }, { children: params.value }))); },
        },
        {
            headerName: "Call Start",
            field: "callStart",
            flex: 1,
            sort: "desc",
            valueFormatter: function (params) {
                if (!params.value)
                    return "N/A";
                return new Date(params.value).toLocaleString();
            },
        },
        {
            headerName: "Call End",
            field: "callEnd",
            flex: 1,
            valueFormatter: function (params) {
                if (!params.value)
                    return "N/A";
                return new Date(params.value).toLocaleString();
            },
        },
        {
            headerName: "Duration",
            field: "billableMinutes",
            flex: 1,
            valueFormatter: function (params) {
                if (!params.value)
                    return "N/A";
                return formatDuration(params.value);
            },
        },
        {
            headerName: "Transfer Time",
            field: "transferMinutes",
            flex: 1,
            valueFormatter: function (params) {
                if (!params.value)
                    return "0:00";
                return formatDuration(params.value);
            },
        },
        {
            headerName: "LLM Model",
            field: "llmModel",
            flex: 1,
            valueFormatter: function (params) { return params.value || "N/A"; },
        },
        {
            headerName: "TTS Model",
            field: "ttsModel",
            flex: 1,
            valueFormatter: function (params) { return params.value || "N/A"; },
        },
        {
            headerName: "STT Model",
            field: "sttModel",
            flex: 1,
            valueFormatter: function (params) { return params.value || "N/A"; },
        },
        {
            headerName: "Total Cost",
            field: "cost.total",
            flex: 1,
            valueFormatter: function (params) {
                if (!params.value)
                    return "$0.00";
                return formatCurrency(params.value);
            },
        },
        {
            headerName: "LLM Cost",
            field: "cost.llm",
            flex: 1,
            valueFormatter: function (params) {
                if (!params.value)
                    return "$0.00";
                return formatCurrency(params.value);
            },
        },
        {
            headerName: "TTS Cost",
            field: "cost.tts",
            flex: 1,
            valueFormatter: function (params) {
                if (!params.value)
                    return "$0.00";
                return formatCurrency(params.value);
            },
        },
        {
            headerName: "STT Cost",
            field: "cost.stt",
            flex: 1,
            valueFormatter: function (params) {
                if (!params.value)
                    return "$0.00";
                return formatCurrency(params.value);
            },
        },
        {
            headerName: "Telephony Cost",
            field: "cost.telephony",
            flex: 1,
            valueFormatter: function (params) {
                if (!params.value)
                    return "$0.00";
                return formatCurrency(params.value);
            },
        },
        {
            headerName: "Transfer Telephony Cost",
            field: "cost.transferTelephony",
            flex: 1,
            valueFormatter: function (params) {
                if (!params.value)
                    return "$0.00";
                return formatCurrency(params.value);
            },
        },
        {
            headerName: "Dowork Margin",
            field: "cost.doworkMargin",
            flex: 1,
            valueFormatter: function (params) {
                if (!params.value)
                    return "$0.00";
                return formatCurrency(params.value);
            },
        },
        {
            headerName: "Outbound",
            field: "isOutbound",
            flex: 1,
            cellRenderer: function (params) { return (_jsx(Chip, __assign({ variant: "outlined", color: params.value ? "warning" : "neutral", size: "sm" }, { children: params.value ? "Yes" : "No" }))); },
        },
        {
            headerName: "Live Agent Requested",
            field: "isLiveAgentRequested",
            flex: 1,
            cellRenderer: function (params) { return (_jsx(Chip, __assign({ variant: "outlined", color: params.value ? "danger" : "neutral", size: "sm" }, { children: params.value ? "Yes" : "No" }))); },
        },
    ]; }, [navigate]);
    var renderCallsTable = function () {
        if (isLoadingCostDashboard) {
            return (_jsxs(Card, { children: [_jsxs(Box, __assign({ sx: { display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 } }, { children: [_jsx(Typography, __assign({ level: "title-lg" }, { children: "Session Details" })), _jsx(Button, __assign({ variant: "outlined", startDecorator: _jsx(DownloadIcon, {}), disabled: true }, { children: "Export CSV" }))] })), _jsx(Box, __assign({ sx: {
                            display: "grid",
                            gridTemplateColumns: "repeat(6, 1fr)",
                            gap: 2,
                            padding: 2,
                        } }, { children: __spreadArray([], Array(18), true).map(function (_, index) { return (_jsx(Box, __assign({ sx: { display: "flex", flexDirection: "column", gap: 1 } }, { children: _jsx(Skeleton, { variant: "rectangular", height: 30 }) }), index)); }) }))] }));
        }
        return (_jsxs(Card, { children: [_jsxs(Box, __assign({ sx: { display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 } }, { children: [_jsx(Typography, __assign({ level: "title-lg" }, { children: "Session Details" })), _jsx(Button, __assign({ variant: "outlined", startDecorator: _jsx(DownloadIcon, {}), onClick: handleExportCSV }, { children: "Export CSV" }))] })), _jsx(Box, __assign({ sx: { width: "100%", height: "600px" }, className: darkMode ? "ag-theme-quartz-dark" : "ag-theme-quartz" }, { children: _jsx(AgGridReact, { rowModelType: "infinite", cacheBlockSize: PAGE_SIZE, pagination: true, paginationPageSize: PAGE_SIZE, columnDefs: columnDefs, defaultColDef: defaultColDef, onGridReady: onGridReady, onSortChanged: onSortChanged, enableCellTextSelection: true, animateRows: true, suppressCellFocus: true, ensureDomOrder: true }) }))] }));
    };
    return (_jsx(Box, __assign({ sx: { overflowY: "auto" } }, { children: _jsxs(Box, __assign({ sx: { pl: 3.5, pr: 4, pt: 1, width: "100%" } }, { children: [_jsx(Typography, __assign({ level: "h1", sx: { mb: 3 } }, { children: "Cost Dashboard" })), _jsx(Card, __assign({ sx: { mb: 1 } }, { children: _jsx(Box, { children: _jsxs(Stack, __assign({ direction: "row", spacing: 2, sx: { mb: 1, flexWrap: "wrap" } }, { children: [_jsx(FormControl, { children: _jsxs(Select, __assign({ size: "sm", value: filter, onChange: function (event, newVal) {
                                            if (!newVal)
                                                return;
                                            setDateRange(newVal);
                                            // If user selects "custom"
                                            if (newVal === FilterEnums.custom) {
                                                setShowDateRangePicker(true);
                                            }
                                            else {
                                                setShowDateRangePicker(false);
                                            }
                                        }, placeholder: "Select Date Range", sx: { minWidth: 200 } }, { children: [_jsx(Option, __assign({ value: FilterEnums.last30Minutes }, { children: "Last 30 Minutes" })), _jsx(Option, __assign({ value: FilterEnums.last1Hour }, { children: "Last Hour" })), _jsx(Option, __assign({ value: FilterEnums.last4Hours }, { children: "Last 4 Hours" })), _jsx(Option, __assign({ value: FilterEnums.last12Hours }, { children: "Last 12 Hours" })), _jsx(Option, __assign({ value: FilterEnums.last24Hours }, { children: "Last 24 Hours" })), _jsx(Option, __assign({ value: FilterEnums.last48Hours }, { children: "Last 48 Hours" })), _jsx(Option, __assign({ value: FilterEnums.today }, { children: "Today" })), _jsx(Option, __assign({ value: FilterEnums.yesterday }, { children: "Yesterday" })), _jsx(Option, __assign({ value: FilterEnums.last3Days }, { children: "Last 3 Days" })), _jsx(Option, __assign({ value: FilterEnums.last7Days }, { children: "Last 7 Days" })), _jsx(Option, __assign({ value: FilterEnums.last1Month }, { children: "Last 1 Month" })), _jsx(Option, __assign({ value: FilterEnums.last3Months }, { children: "Last 3 Months" })), _jsx(Option, __assign({ value: FilterEnums.all }, { children: "All" })), _jsx(Option, __assign({ value: FilterEnums.custom, onClick: function () {
                                                    setDateRange(FilterEnums.custom);
                                                    setShowDateRangePicker(true);
                                                } }, { children: displayRange() }))] })) }), _jsx(FormControl, { children: _jsxs(Select, __assign({ value: selectedFlow, onChange: function (_, value) { return setSelectedFlow(value); }, placeholder: "All Flows", size: "sm", sx: { minWidth: 150 } }, { children: [_jsx(Option, __assign({ value: "" }, { children: "All Flows" })), flows.map(function (flow) { return (_jsx(Option, __assign({ value: flow.flowId }, { children: flow.flowName }), flow.flowId)); })] })) })] })) }) })), filter === FilterEnums.custom && dateRangePickerVisible && (_jsx(Box, __assign({ ref: dateRangeRef, sx: {
                        position: "absolute",
                        zIndex: 99999,
                        display: "inline-block",
                    } }, { children: _jsx(DateRange, { ranges: selectedRange, onChange: function (item) {
                            setSelectedRange([item.selection]);
                            setCustomStartDate(item.selection.startDate);
                            setCustomEndDate(item.selection.endDate);
                        }, moveRangeOnFirstSelection: false, editableDateInputs: true, className: mode === "dark" ? "custom-date-range-picker" : "" }) }))), renderCostMetricsCards(), renderDailyCostChart(), renderCallsTable()] })) })));
};
